/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/axios.js"

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    updateCurrImg({ commit },input) {
      debugger;
      return new Promise((resolve,reject)=>{
        debugger;
        if (input.target.files && input.target.files[0]) {
          let data = new FormData();
          data.append("file", input.target.files[0]);
          debugger;
          axios.post("API/Common/UploadFile", data,{
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(response => {
            console.log(commit);
            resolve(response);

          }).catch((error) => { reject(error) });
        }
      });
    },
    updateCurrPackage({ commit },input) {
      debugger
      return new Promise((resolve,reject)=>{
        if (input) {
          debugger
          let data = new FormData();
          data.append("file", input);
          axios.post("API/Common/UploadFile", data,{
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(response => {
            console.log(commit);
            resolve(response);
            debugger;

          }).catch((error) => {debugger; reject(error) });
        }
        debugger;
      });
    },
    fetchNotifications({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("/GetUserNotification")
          .then((response) => {
            commit('SET_Notifications', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole({ dispatch }, payload) {
      // Change client side
      payload.aclChangeRole(payload.userRole)

      // Make API call to server for changing role

      // Change userInfo in localStorage and store
      dispatch('updateUserInfo', {userRole: payload.userRole})
    },
}

export default actions
